import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, MessageCircle, Facebook, Instagram, Linkedin, Twitter, ArrowUpRight } from 'lucide-react';
import { brand, marketplaces } from '../mock';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'About Us', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Marketplaces', to: '/marketplaces' },
  { label: 'Testimonials', to: '/testimonials' },
  { label: 'Contact', to: '/contact' },
];

export default function Footer() {
  return (
    <footer className="bg-[#0d1f16] text-neutral-300 pt-16 pb-6">
      <div className="container-x grid md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            <div className="w-10 h-10 rounded-xl bg-[color:var(--brand-green)] flex items-center justify-center text-white font-black shadow-md">
              EC
            </div>
            <div className="leading-tight">
              <div className="font-black text-white text-sm">EC SAFETRADE</div>
              <div className="text-[10px] font-semibold text-[color:var(--brand-orange)] tracking-widest">SOLUTIONS</div>
            </div>
          </div>
          <p className="text-sm leading-relaxed text-neutral-400">
            Your growth partner for E-Commerce marketplaces, social media marketing and website
            development. Serving 30,000+ merchants worldwide.
          </p>
          <div className="mt-5 flex gap-3">
            {[Facebook, Instagram, Linkedin, Twitter].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center hover:bg-[color:var(--brand-green)] transition-colors"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Quick Links</h4>
          <ul className="space-y-2 text-sm">
            {quickLinks.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-[color:var(--brand-orange)] transition-colors flex items-center gap-1">
                  {l.label}
                </Link>
              </li>
            ))}
            <li>
              <a
                href="https://connectus.ecsafetradesolution.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[color:var(--brand-orange)] transition-colors flex items-center gap-1 font-semibold text-[color:var(--brand-orange)]"
              >
                Connect With Us <ArrowUpRight size={12} />
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Marketplaces</h4>
          <ul className="space-y-2 text-sm">
            {marketplaces.slice(0, 6).map((m) => (
              <li key={m.slug}>
                <Link to="/marketplaces" className="hover:text-[color:var(--brand-orange)] transition-colors flex items-center gap-1">
                  {m.name} Services <ArrowUpRight size={12} />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-white font-bold mb-4">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 text-[color:var(--brand-orange)] shrink-0" />
              <div>
                <div className="text-[10px] font-bold text-white/70 uppercase tracking-wider">Call</div>
                <a href={`tel:${brand.phoneRaw}`} className="hover:text-white">{brand.phone}</a>
              </div>
            </li>
            <li className="flex items-start gap-2">
              <MessageCircle size={14} className="mt-1 text-[color:var(--brand-orange)] shrink-0" />
              <div>
                <div className="text-[10px] font-bold text-white/70 uppercase tracking-wider">WhatsApp</div>
                <a
                  href={`https://wa.me/${brand.whatsapp}?text=${encodeURIComponent(brand.whatsappMessage)}`}
                  target="_blank"
                  rel="noreferrer"
                  className="hover:text-white"
                >
                  {brand.whatsappDisplay}
                </a>
              </div>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 text-[color:var(--brand-orange)] shrink-0" />
              <a href={`mailto:${brand.email}`} className="hover:text-white break-all">{brand.email}</a>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-[color:var(--brand-orange)] shrink-0" />
              <div>
                <div className="text-[10px] font-bold text-white/70 uppercase tracking-wider">Head Office</div>
                <div>{brand.address}</div>
              </div>
            </li>
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-[color:var(--brand-orange)] shrink-0" />
              <div>
                <div className="text-[10px] font-bold text-white/70 uppercase tracking-wider">Branch Office</div>
                <div>{brand.branchOffice}</div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div className="container-x mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-neutral-500">
        <div>
          &copy; {new Date().getFullYear()} EC SAFETRADE SOLUTIONS. All rights reserved.
        </div>
        <div className="flex gap-5">
          <Link to="#" className="hover:text-white">Terms of Service</Link>
          <Link to="#" className="hover:text-white">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}
